import { BrandBar } from '../components/index.js';
import { LegalFooter } from '../components/LegalFooter.js';
import { fallbackSrc, SKYLINE, srcSet } from '../assets/images.js';
import { OFFERING } from '@shared/config.js';

const VALUE_ITEMS = [
  {
    title: 'An indicative 0–100 NDSS score',
    detail: 'Placed in one of four bands: foundation, developing, mature, leading.',
  },
  {
    title: 'A breakdown across 8 categories',
    detail: "See where you're strongest and where the exposure sits.",
  },
  {
    title: 'The NDSS Scorecard (PDF)',
    detail: 'A one-page headline result, yours to keep and share internally.',
  },
] as const;

export default function Landing({ onStart }: { onStart: () => void }) {
  return (
    <div className="app app--fixed">
      <BrandBar tag={`${OFFERING.name} · ${OFFERING.tier}`} />

      <main className="screen screen--center">
        <div className="landing-grid">
          <div>
            <span className="kicker">
              {OFFERING.name} · {OFFERING.tier}
            </span>
            <h1 className="headline-serif">Sovereignty is more than where your data sits.</h1>
            <p className="lede">
              Eight dimensions of digital control. A free 12-question self-check, about 5–10
              minutes, with an indicative 0–100 score and the {OFFERING.deliverable}.
            </p>

            <div className="landing-cta-row">
              <button type="button" className="btn btn-primary btn-block" onClick={onStart}>
                Start the scan
                <span className="btn-arrow" aria-hidden="true" />
              </button>
              <div className="meta-row">
                <span>12 questions</span>
                <i aria-hidden="true" />
                <span>~5–10 min</span>
                <i aria-hidden="true" />
                <span>free · no login</span>
              </div>
            </div>

            {/* Honesty note. Names the E1 floor up front rather than after the
                score — the evidence gap is the upsell, not a disclaimer. */}
            <p className="honesty landing-honesty" style={{ maxWidth: 520 }}>
              <span className="info-i" aria-hidden="true">
                i
              </span>
              <span>
                This is an <b>indicative scan</b>, not a full assessment. It's based on your
                answers alone — evidence level <b>E1</b>. A Deep Scan adds documents, interviews
                and technical checks across all eight categories.
              </span>
            </p>
          </div>

          <div className="navy-panel landing-panel">
            {/* Decorative only — the panel reads identically without it, which
                is why alt is empty and the whole thing is aria-hidden. It sits
                under a near-opaque navy wash so the white text keeps its
                contrast ratio regardless of what the photo is doing. */}
            <img
              className="panel-photo"
              src={fallbackSrc(SKYLINE)}
              srcSet={srcSet(SKYLINE)}
              sizes="(min-width: 900px) 48vw, 100vw"
              alt={SKYLINE.alt}
              aria-hidden="true"
              loading="lazy"
              decoding="async"
            />
            <p className="navy-panel-h">What you'll get</p>
            <div>
              {VALUE_ITEMS.map((item) => (
                <div className="value-item" key={item.title}>
                  <span className="trade-check on-navy" aria-hidden="true" />
                  <div>
                    <div className="value-item-t">{item.title}</div>
                    <div className="value-item-d">{item.detail}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>

      <LegalFooter />
    </div>
  );
}
